import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [].concat(Object.values(require('@/plugins/router/common?lazy')))
})

export default () => {
  return router
}
